<template>
    <VJoyProductTour
        ref="productTourRef"
        open
        :spotlight-selector="`[${target}]`"
        :position="position"
        :data-testid="dataTestId"
        :close-button="false"
        @product-tour:hide="emit('closed')"
    >
        <template #product-tour-content>
            {{ t(content) }}
        </template>

        <template #product-tour-next>
            <VJoyButton :label="t(ctaLabel)" size="small" variant="main" :data-testid="`${dataTestId}-cta`" @click="close()" />
        </template>
    </VJoyProductTour>
</template>
<script setup lang="ts">
    import {ref} from 'vue';
    import {useTranslation} from '#imports';
    import {VJoyButton, VJoyProductTour} from '@maltjoy/core-vue';
    import type {ProductTourInfo} from '../jobsSteps';

    const productTourRef = ref<InstanceType<typeof VJoyProductTour>>();
    const {t} = useTranslation();

    defineProps<ProductTourInfo>();

    const emit = defineEmits(['closed']);

    function close() {
        productTourRef.value?.hide();
    }
</script>
